import { render } from "./Noticias.vue?vue&type=template&id=f95e204c&scoped=true"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"

import "./Noticias.vue?vue&type=style&index=0&id=f95e204c&lang=scss&scoped=true"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95e204c"]])

export default __exports__